import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import ChatPopup from './ChatPopup';
import ChatPopupBar from './ChatPopupBar';
import { useChatPopup } from '../../contexts/ChatPopupContext';
import { CONTEXTS } from 'figshelf-modules';

/**
 * Manages all chat popup windows
 * Renders active chat windows and minimized chat bar
 */
const ChatPopupManager = () => {
  const { isSignedIn, isLoading } = CONTEXTS.useAuth();
  const { getActiveChats, closeChat, minimizeChat, openChats } = useChatPopup();
  const activeChats = getActiveChats();
  const location = useLocation();

  // Debug logging
  useEffect(() => {
  }, [isSignedIn, isLoading, openChats, activeChats]);

  if (isLoading) {
    return null;
  }

  if (!isSignedIn) {
    return null;
  }

  // Note: We no longer hide popups on /messages page to allow "Open in Popup" to work
  // The popup will still render and user can navigate away from messages page


  return (
    <>
      {/* Active Chat Windows */}
      <Box sx={{right: '100px'}}>
        {activeChats.map((chat, index) => {
          console.log('Rendering ChatPopup:', chat.conversationId, 'at position', index);
          return (
            <ChatPopup
              key={chat.conversationId}
              conversationId={chat.conversationId}
              onClose={() => closeChat(chat.conversationId)}
              onMinimize={() => minimizeChat(chat.conversationId)}
              isMinimized={chat.isMinimized}
              position={index}
            />
          );
        })}
      </Box>

      {/* Minimized Chat Bar */}
      <ChatPopupBar />
    </>
  );
};

export default ChatPopupManager;
